"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_overlay_1 = __importDefault(require("@doordash/component-overlay"));
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var App_1 = __importDefault(require("../App/App"));
var enums_1 = require("../Common/utils/enums");
var i18n_1 = require("../i18n/i18n");
var EnterCode_1 = __importDefault(require("./components/EnterCode"));
var GetHelp_1 = __importDefault(require("./components/GetHelp"));
var MfaError_1 = __importDefault(require("./components/MfaError"));
var MfaOptions_1 = __importDefault(require("./components/MfaOptions"));
// tslint:disable-next-line:max-line-length
var useGeneratePasscodeMutation_1 = __importDefault(require("./Providers/useGeneratePasscodeMutation"));
var useVerifyPasscodeMutation_1 = __importDefault(require("./Providers/useVerifyPasscodeMutation"));
var TwoFactorAuthenticationStrings_1 = __importDefault(require("./TwoFactorAuthenticationStrings"));
var VerifyAccountContext_1 = __importDefault(require("./VerifyAccountContext"));
var VerifyAccountStyles_1 = require("./VerifyAccountStyles");
var VerifyAccountTracking_1 = require("./VerifyAccountTracking");
var VerifyPasscode = function (_a) {
    var loadData = _a.loadData, primaryText = _a.primaryText;
    var _b = useGeneratePasscodeMutation_1["default"](), sendCode = _b.sendCode, sendData = _b.sendData, sendError = _b.sendError, sendLoading = _b.sendLoading;
    var _c = useVerifyPasscodeMutation_1["default"](), verifyCode = _c.verifyCode, verifyLoading = _c.verifyLoading, verifyError = _c.verifyError;
    var experience = React.useContext(App_1["default"]).experience;
    var _d = React.useContext(VerifyAccountContext_1["default"]), blockChannelSwitch = _d.blockChannelSwitch, channel = _d.channel;
    var resultData = sendError ? null : sendData || loadData;
    var experienceStrings = i18n_1.getStringsForExperience(TwoFactorAuthenticationStrings_1["default"], experience);
    return (React.createElement(component_overlay_1["default"], { isVisible: sendLoading, type: component_overlay_1["default"].Types.Loading },
        React.createElement(design_language_1.StackChildren, null,
            React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.XxLarge },
                React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext, textAlign: design_language_1.Text.TextAlignments.Center }, primaryText)),
            React.createElement(EnterCode_1["default"], { clearError: sendLoading, verifyCode: verifyCode, verifyError: verifyError }),
            resultData && resultData.contactAddress && (React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext }, TwoFactorAuthenticationStrings_1["default"].weSentACodeTo(resultData.contactAddress))),
            React.createElement(MfaError_1["default"], { clearError: sendLoading || verifyLoading, sendData: sendData, sendError: sendError, verifyError: verifyError }),
            React.createElement(VerifyAccountStyles_1.MfaOptionsWrapper, null,
                React.createElement(MfaOptions_1["default"], { channel: channel, sendCode: sendCode, text: TwoFactorAuthenticationStrings_1["default"].resendCode(), track: VerifyAccountTracking_1.trackOnResendCode }),
                React.createElement("div", null, "\u00B7"),
                !blockChannelSwitch && (React.createElement(design_language_1.InlineChildren, { alignItems: design_language_1.InlineChildren.Alignment.Center, size: design_language_1.InlineChildren.Sizes.XxSmall },
                    React.createElement(MfaOptions_1["default"], { channel: channel === enums_1.TwoFactorChannels.SMS
                            ? enums_1.TwoFactorChannels.Email
                            : enums_1.TwoFactorChannels.SMS, sendCode: sendCode, text: channel === enums_1.TwoFactorChannels.SMS
                            ? TwoFactorAuthenticationStrings_1["default"].sendToEmail()
                            : TwoFactorAuthenticationStrings_1["default"].sendToMobile(), track: VerifyAccountTracking_1.trackOnChannelSwitch }),
                    React.createElement("div", null, "\u00B7"))),
                React.createElement(GetHelp_1["default"], { isLink: true, isInline: true })))));
};
exports["default"] = VerifyPasscode;
